var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("operationType")
                  },
                  model: {
                    value: _vm.paramsData.type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "type", $$v)
                    },
                    expression: "paramsData.type"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("add"), value: 1 }
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("modify"), value: 2 }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("operator")
                  },
                  model: {
                    value: _vm.paramsData.admin_id,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "admin_id", $$v)
                    },
                    expression: "paramsData.admin_id"
                  }
                },
                _vm._l(_vm.usersList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.nickname, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("belongArea")
                  },
                  model: {
                    value: _vm.paramsData.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "channel", $$v)
                    },
                    expression: "paramsData.channel"
                  }
                },
                _vm._l(_vm.serverChannel, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-date-picker", {
                attrs: {
                  clearable: "",
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": _vm.$t("range"),
                  "start-placeholder": _vm.$t("startDate"),
                  "end-placeholder": _vm.$t("endDate")
                },
                model: {
                  value: _vm.value2,
                  callback: function($$v) {
                    _vm.value2 = $$v
                  },
                  expression: "value2"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.list, border: "" } },
        [
          _c("el-table-column", {
            attrs: {
              prop: "expire",
              label: _vm.$t("operationType"),
              align: "center",
              "min-width": "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.type == "1" ? _vm.$t("add") : _vm.$t("modify")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "admin_id",
              label: _vm.$t("operator"),
              align: "center",
              "min-width": "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "expire",
              label: _vm.$t("serverName"),
              align: "center",
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.params.request.serverName) + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverID",
              label: _vm.$t("serverId"),
              align: "center",
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.params.request.serverID) + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "areaID",
              label: _vm.$t("serverBelongArea"),
              align: "center",
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.params.request.areaID) + " ")]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverIP",
              label: _vm.$t("serverIpAddress"),
              align: "center",
              "min-width": "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.params.request.serverIP) + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "serverPort",
              label: _vm.$t("serverPort"),
              align: "center",
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(" " + _vm._s(row.params.request.serverPort) + " ")
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "config_state",
              label: _vm.$t("configServerStatusA"),
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.configState.find(function(i) {
                            return (
                              i.value ==
                              (row.params.request.state ||
                                row.params.request.config_state)
                            )
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "new_tag",
              label: _vm.$t("isNewServer"),
              "min-width": "130"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.params.request.new_tag == "true"
                            ? _vm.$t("yes")
                            : _vm.$t("no")
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_recomm",
              label: _vm.$t("recommendServerTag"),
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.recommList.find(function(i) {
                            return i.value == row.params.request.is_recomm
                          }).label
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "push_msg",
              label: _vm.$t("serverPushMessage"),
              "min-width": "190",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(
                        " " + _vm._s(row.params.request.push_msg || "/") + " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ver_max",
              label: _vm.$t("maxVersion"),
              "min-width": "120",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.params.request.ver_max) + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "ver_min",
              label: _vm.$t("minVersion"),
              "min-width": "120",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.params.request.ver_min) + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "OpenTime",
              label: _vm.$t("openServerTime"),
              "min-width": "260"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.params.request.OpenTime
                            ? typeof row.params.request.OpenTime === "string"
                              ? row.params.request.OpenTime
                              : _vm.$times.formDate(
                                  row.params.request.OpenTime * 1000
                                )
                            : "/"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "timestamp",
              label: _vm.$t("submitTime"),
              align: "center",
              "min-width": "180"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "is_timing",
              label: _vm.$t("isScheduled"),
              align: "center",
              "min-width": "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            row.params.request.is_timing == 1
                              ? _vm.$t("scheduledTask")
                              : _vm.$t("normalTask")
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "timestamp",
              label: _vm.$t("scheduledTime"),
              align: "center",
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            row.params.request.showTime
                              ? _vm.$times.timestampToTime(
                                  row.params.request.showTime / 1000
                                )
                              : "/"
                          ) +
                          " "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "done_time",
              label: _vm.$t("scheduledExecuteTime"),
              align: "center",
              "min-width": "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      _vm._v(" " + _vm._s(row.params.done_time || "/") + " ")
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "result",
              label: _vm.$t("status"),
              align: "center",
              fixed: "right",
              "min-width": "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "text-ellipsis-1" }, [
                      row.update_state == 0
                        ? _c("p", [_vm._v(_vm._s(_vm.$t("notExecuted")))])
                        : _vm._e(),
                      row.update_state == 1
                        ? _c("p", [_vm._v(_vm._s(_vm.$t("executedSuccess")))])
                        : _vm._e(),
                      row.update_state == 2
                        ? _c("p", [_vm._v(_vm._s(_vm.$t("executedFailed")))])
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total,
          page_size: _vm.paramsData.page_size
        },
        on: { "current-change": _vm.getList, "size-change": _vm.sizeChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }